export default __webpack_public_path__ + "static/media/All.2b105b60.png";